import { Alert, Box, Card, Chip, IconButton } from "@mui/material";
import StatusChangeItem from "../../../components/common/StatusChangeItem";
import localize from "../../../common/localize";
import { Delete, Edit } from "@mui/icons-material";

export default function StatusChangeConfigInfo({
  statusChangeObj,
  onEditButtonClick,
  onDeleteButtonclick,
  hideDeleteButton,
}) {
  return (
    <Card
      variant="outlined"
      style={{ borderRadius: "5px" }}
      className="flex gap-2 w-full justify-center p-2"
    >
      <Box className="w-full flex flex-col gap-1">
        <Box className="w-full flex flex-row-reverse justify-between gap-2">
          <Box className="w-full">
            <StatusChangeItem
              initialStatus={statusChangeObj.InitialStatus}
              finalStatus={statusChangeObj.FinalStatus}
            />
          </Box>
        </Box>

        {statusChangeObj.FinalStatus && (
          <Box className="w-full flex flex-row-reverse items-center justify-between gap-2">
            {statusChangeObj.IsAdministrative && (
              <Chip
                sx={{
                  "& .MuiChip-deleteIcon": {
                    color: "white",
                  },
                  "& .MuiChip-deleteIcon:hover": {
                    color: "white",
                  },
                }}
                style={{
                  margin: "2px",
                  fontSize: "12px",
                  fontWeight: 400,
                  backgroundColor: "#10366E",
                  color: "white",
                }}
                label={localize.only_web}
              />
            )}

            <Alert
              className="text-xs w-full"
              severity={statusChangeObj.DynamicForm ? "warning" : "info"}
            >
              <p className="text-xs">
                <b>{localize.form}: </b>
                {statusChangeObj.DynamicForm
                  ? statusChangeObj.DynamicForm.Name
                  : localize.not_assigned_masc}
              </p>
            </Alert>

            <Box className="flex flex-col" sx={{ width: "20px" }}>
              <IconButton onClick={onEditButtonClick}>
                <Edit
                  sx={{ width: "15px", height: "15px" }}
                  className="info_icon_color"
                />
              </IconButton>

              {!hideDeleteButton && (
                <IconButton onClick={onDeleteButtonclick}>
                  <Delete
                    sx={{ width: "15px", height: "15px" }}
                    className="error_icon_color"
                  />
                </IconButton>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Card>
  );
}
